import { render, staticRenderFns } from "./KarmaRequestAdd.vue?vue&type=template&id=1d1f2b6b&"
import script from "./KarmaRequestAdd.vue?vue&type=script&lang=js&"
export * from "./KarmaRequestAdd.vue?vue&type=script&lang=js&"
import style0 from "./KarmaRequestAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports